<template>
  <div class="unload-modal">
    <div class="crm-form-fields">
      <div class="crm-form-field">
        <span class="crm-title">
          Фильтры:
        </span>
      </div>
    </div>

    <div class="crm-form-fields">
      <div class="crm-form-field">
        <base-radio-button
          v-model="selectedType"
          :name="1"
        >
          Новые записи, добавленные за период:
        </base-radio-button>
      </div>
    </div>

    <div
      :class="{ disabled: shouldBeDisabled(1) }"
      class="crm-form-fields"
    >
      <div class="crm-form-field">
        <span class="preposition">с</span>
        <base-date-picker
          v-model="$v.unloadingFrom.$model"
          :error="$v.unloadingFrom.$error"
          :errors="errorsValidation.unloadingFrom"
          :max-date="maxUnloadingDateFrom"
          :disabled="shouldBeDisabled(1)"
        />

        <div class="divider">
          <div class="divider-row" />
        </div>

        <span class="preposition">по</span>
        <base-date-picker
          v-model="$v.unloadingTo.$model"
          :error="$v.unloadingTo.$error"
          :errors="errorsValidation.unloadingTo"
          :min-date="minUnloadingDateTo"
          :max-date="maxDateTo"
          :disabled="shouldBeDisabled(1)"
        />
      </div>
    </div>

    <!-- checkRoleAccess_(['Administrator']) -->
    <template v-if="checkFeatureAccess({ name: 'Возможность получить выгрузку по медицинской организации', url: '/doctors' })">
      <div class="crm-form-fields">
        <div class="crm-form-field">
          <base-radio-button
            v-model="selectedType"
            :name="2"
          >
            По медицинской организации:
          </base-radio-button>
        </div>
      </div>

      <div
        :class="{ disabled: shouldBeDisabled(2) }"
        class="crm-form-fields"
      >
        <div class="crm-form-field">
          <base-async-select
            v-model="$v.clinic.$model"
            :error="$v.clinic.$error"
            :errors="errorsValidation.clinic"
            :disabled="shouldBeDisabled(2)"
            :fetch-function="fetchClinic"
            class="crm-fluid"
            server-paginated
          />
        </div>
      </div>
    </template>

    <div class="crm-form-fields">
      <div class="crm-wrapper-buttons">
        <!-- <base-button
          :type="$const.SECONDARY_BUTTON"
          class="crm-button"
          @click="onClickClose"
        >
          Отменить
        </base-button> -->

        <base-button
          :type="$const.PRIMARY_BUTTON"
          :disabled="isSaving"
          class="crm-button"
          @click="onClickSave"
        >
          Сформировать
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { isValid, formatISO } from 'date-fns';
import { showMessage } from '@/helpers/utils';
import {
  BaseRadioButton, BaseDatePicker, BaseAsyncSelect, BaseButton,
} from '@/components/base';
import { mixinRoles } from '@/mixins';

export default {
  name: 'DoctorUnloadModal',
  components: {
    BaseRadioButton,
    BaseDatePicker,
    BaseAsyncSelect,
    BaseButton,
  },
  mixins: [validationMixin, mixinRoles],
  data() {
    return {
      selectedType: 1,

      unloadingFrom: null,
      unloadingTo: null,

      clinic: null,

      isSaving: false,
    };
  },
  validations() {
    return {
      unloadingFrom: {
        required: this.selectedType === 1 ? required : () => true,
        isValid: this.selectedType === 1 ? isValid : () => true,
      },
      unloadingTo: {
        required: this.selectedType === 1 ? required : () => true,
        isValid: this.selectedType === 1 ? isValid : () => true,
      },
      clinic: {
        required: this.selectedType === 2 ? required : () => true,
      },
    };
  },
  computed: {
    errorsValidation() {
      const errors = {};

      errors.unloadingTo = [];
      if (!this.$v.unloadingTo.required) {
        errors.unloadingTo.push('Поле не может быть пустым');
      }
      if (!this.$v.unloadingTo.isValid) {
        errors.unloadingTo.push('Некорректное значение поля');
      }

      errors.unloadingFrom = [];
      if (!this.$v.unloadingFrom.required) {
        errors.unloadingFrom.push('Поле не может быть пустым');
      }
      if (!this.$v.unloadingFrom.isValid) {
        errors.unloadingFrom.push('Некорректное значение поля');
      }

      errors.clinic = [];
      if (!this.$v.clinic.required) {
        errors.clinic.push('Поле не может быть пустым');
      }

      return errors;
    },
    maxUnloadingDateFrom() {
      return this.unloadingTo || new Date();
    },
    minUnloadingDateTo() {
      return this.unloadingFrom || null;
    },
    maxDateTo() {
      return new Date();
    },
  },
  methods: {
    shouldBeDisabled(index) {
      return this.selectedType !== index;
    },
    async fetchClinic({ query, skip, take }) {
      const clinics = await this.$store.dispatch(this.$types.CLINICS_FETCH, {
        skip,
        take,
        filter: {
          query,
          network: null,
          city: null,
        },
      });

      return clinics.map((clinic) => ({ value: clinic.id, name: clinic.title }));
    },
    onClickClose() {
      this.$emit('vuedals:close');
    },
    async onClickSave() {
      this.$v.$touch();

      if (this.$v.$error) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });

        return;
      }

      const filter = {};

      if (this.selectedType === 1) {
        filter.startDate = formatISO(this.unloadingFrom);
        filter.endDate = formatISO(this.unloadingTo);
      } else if (this.selectedType === 2) {
        filter.clinicId = this.clinic.value;
        filter.clinicName = this.clinic.name;
      }

      try {
        this.isSaving = true;
        await this.$store.dispatch(this.$types.DOCTOR_UNLOAD_FETCH, filter);
        this.$emit('vuedals:close');
      } catch (e) {
        console.log('Ошибка выгрузки');
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.crm-form-fields {
  &.disabled {
    opacity: 0.4;
  }

  &:not(:last-child) {
    margin-bottom: 30px;
  }

  .crm-form-field {
    align-items: center;
  }
}
.preposition {
  margin-right: 10px;
}
</style>
